type MemberProfileDisplayMode = 'photo' | 'svg';

const getModeStorageKey = (userId: string, classId: string) =>
  `member_profile_display_mode_${userId}_${classId}`;

export const readMemberProfileDisplayMode = (
  userId: string,
  classId: string
): MemberProfileDisplayMode => {
  if (typeof window === 'undefined') return 'svg';
  try {
    const raw = window.localStorage.getItem(getModeStorageKey(userId, classId));
    return raw === 'photo' ? 'photo' : 'svg';
  } catch {
    return 'svg';
  }
};

export const writeMemberProfileDisplayMode = (
  userId: string,
  classId: string,
  mode: MemberProfileDisplayMode
): void => {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(getModeStorageKey(userId, classId), mode);
    window.dispatchEvent(
      new CustomEvent('memberProfileDisplayModeChanged', {
        detail: { userId, classId, mode }
      })
    );
  } catch {
    // ignore
  }
};

export const isExternalProfileImageSource = (value?: string): boolean => {
  if (!value) return false;
  return (
    value.startsWith('http://') ||
    value.startsWith('https://') ||
    value.startsWith('data:image/')
  );
};

export const resolveMemberProfileSource = (
  member: { profileImage?: string; photoProfileUrl?: string; photoProfileVersion?: number },
  mode: MemberProfileDisplayMode
): string => {
  if (mode === 'photo' && member.photoProfileUrl) {
    if (member.photoProfileVersion) {
      const separator = member.photoProfileUrl.includes('?') ? '&' : '?';
      return `${member.photoProfileUrl}${separator}v=${member.photoProfileVersion}`;
    }
    return member.photoProfileUrl;
  }
  return member.profileImage || 'basic-0';
};

export type { MemberProfileDisplayMode };
